export const USERS_LIST_REQUEST = 'USERS_LIST_REQUEST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_FAIL = 'USERS_LIST_FAIL';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const CHANGEPASSWORD_REQUEST = 'CHANGEPASSWORD_REQUEST';
export const CHANGEPASSWORD_SUCCESS = 'CHANGEPASSWORD_SUCCESS';
export const CHANGEPASSWORD_FAIL = 'CHANGEPASSWORD_FAIL';
export const CHANGEPASSWORD_RESET = 'CHANGEPASSWORD_RESET';